type OtpContext = 'payer_information' | 'signup';

const OtpChannel = {
  Email: 'email',
  Sms: 'sms',
} as const;

type OtpChannel = (typeof OtpChannel)[keyof typeof OtpChannel];

type SendOtpParams = {
  email: string;
  phone?: string;
  senderName?: string;
  recipientName?: string;
  context: OtpContext;
  channel: OtpChannel;
  platform?: string;
  portalCode?: string;
  countryFrom?: string;
  countryTo?: string;
};

type SendOtpResponse = {
  sent: boolean;
  expiresIn: number;
};

type VerifyOtpParams = {
  recipient: string;
  code: string;
};

type VerifyOtpResponse = {
  verified: boolean;
};

export { OtpChannel };
export type {
  OtpContext,
  SendOtpParams,
  SendOtpResponse,
  VerifyOtpParams,
  VerifyOtpResponse,
};
